import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "accentInput", "accentHex",
    "leadTypeRow", "leadTypeSwatch", "leadTypeInput", "leadTypeHex"
  ]
  // Rendered by the Accent Color form's data-controller element from
  // WhitelabelRecord::DEFAULT_COLORS[:primary] (branding.html.haml) — kept
  // server-side so this file has no hardcoded brand-red literal to drift out
  // of sync with the Ruby constant / $gl-primary token.
  static values = { defaultPrimary: String }

  updateAccentHex() {
    const color = this.accentInputTarget.value
    this.accentHexTarget.textContent = color
  }

  updateLeadTypeSwatch(event) {
    const input = event.target
    const row = input.closest('[data-branding-settings-target="leadTypeRow"]')
    if (!row) return

    const swatch = row.querySelector('[data-branding-settings-target="leadTypeSwatch"]')
    const hex = row.querySelector('[data-branding-settings-target="leadTypeHex"]')

    if (swatch) swatch.style.backgroundColor = input.value
    if (hex) hex.textContent = input.value
  }

  resetAccent() {
    const defaultAccent = this.defaultPrimaryValue
    this.accentInputTarget.value = defaultAccent
    this.accentHexTarget.textContent = defaultAccent
    this.dispatch("change")
    this._notifyDirty()
  }

  resetColors() {
    this.leadTypeRowTargets.forEach((row, index) => {
      const defaultColor = row.dataset.defaultColor
      if (!defaultColor) return

      const input = this.leadTypeInputTargets[index]
      const swatch = this.leadTypeSwatchTargets[index]
      const hex = this.leadTypeHexTargets[index]

      if (input) input.value = defaultColor
      if (swatch) swatch.style.backgroundColor = defaultColor
      if (hex) hex.textContent = defaultColor
    })

    this.dispatch("change")
    this._notifyDirty()
  }

  // Programmatic value resets don't fire native input/change events, so the
  // card-dirty controller (which listens for those bubbling on the form) never
  // re-syncs. Emit a bubbling native input event so the submit button correctly
  // re-disables when a reset returns the form to its saved state.
  _notifyDirty() {
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
